import { BonusAmountCard, fromNanoToUnit } from '@/entities/bonus'
import { IBonus } from '@/shared/api/bonuses'
import { IWalletBalance } from '@/shared/types'
import { Loader } from '@/shared/ui/loader'
import { NoTableData } from '@/shared/ui/no-table-data'
import { Table } from '@/shared/ui/table'
import { ColumnDef } from '@tanstack/react-table'
import React from 'react'

interface BonusWalletProps {
    wallet: IWalletBalance
    bonuses: IBonus[]
    bonusesLoading: boolean
}

export const BonusWallet: React.FC<BonusWalletProps> = ({ wallet, bonuses, bonusesLoading }) => {
    const columns: ColumnDef<IBonus, any>[] = [
        {
            accessorFn: (bonus) => (
                <div className="flex gap-2 items-center">
                    <div className="w-8 h-8 rounded-full overflow-hidden">
                        <img src={bonus.image} />
                    </div>
                    <div className="flex flex-col gap-[2px]">
                        <div className="text-base">
                            {bonus.symbol}
                        </div>
                        <div className="text-[13px] text-[#828282]">
                            {bonus.name}
                        </div>
                    </div>
                </div>
            ),
            enableSorting: false,
            id: 'name',
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Бонус</div>,
        },
        {
            accessorFn: (bonus) => bonus,
            enableSorting: false,
            id: 'balance',
            cell: info => {
                const bonus: IBonus = info.getValue()
                return (
                    <div className="w-fit">
                        <BonusAmountCard amountNano={wallet[bonus.id] ?? 0} />
                    </div>
                )
            },
            header: () => <div className="!text-start">Всего</div>,
        },
        {
            accessorFn: (bonus) => `${fromNanoToUnit(bonus.price_oem_nano).toFixed(2)} ₽`,
            id: 'price',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start">Стоимость бонуса в руб</div>,
        },
    ]
    return (
        <>
            {Boolean(bonuses.length) &&
                <div className="table_box">
                    <Table columns={columns} data={bonuses} />
                </div>
            }
            {(!Boolean(bonuses.length) && bonusesLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(bonuses.length) && !bonusesLoading) &&
                <NoTableData label="Нет данных о бонусах"/>
            }
        </>
    )
}